import { environment } from '../../../environments/environment';

export class ServiceConfig {
    public static DOMAINAPI = environment.baseUrl;
    // public static SYNTHESISAPI = environment.synthesisUrl;
    public static API_AUTH = ServiceConfig.DOMAINAPI + '/api/';
    public static MADPLATFORMBASE = environment.madBaseUrlToConnect;
    public services = {
        // Master Data API's
        MasterConfigList : {url: ServiceConfig.API_AUTH + 'module/config/types/', header: true, autherization: false, dataType: 'API'},
        DeviceStatusList : {url: ServiceConfig.API_AUTH + 'module/device/status/', header: true, autherization: false, dataType: 'API'},
        GetMasterMenuList : {url: ServiceConfig.API_AUTH + 'module/menus/', header: true, autherization: false, dataType: 'API'},
        GetMasterPermissionList : {url: ServiceConfig.API_AUTH + 'module/permissions/', header: true, autherization: false, dataType: 'API'},

        // Login API's
        login : {url: ServiceConfig.API_AUTH + 'user/login/', header: true, autherization: false, dataType: 'API'},
        logout : {url: ServiceConfig.API_AUTH + 'user/logout/', header: true, autherization: true, dataType: 'API'},

        // Device API's
        GetDeviceTypeList: {url: ServiceConfig.API_AUTH + 'device/type/', header: true, autherization: true, dataType: 'API'},
        GetDeviceList : {url: ServiceConfig.API_AUTH + 'inventory/device/', header: true, autherization: true, dataType: 'API'},

        // User API's
        GetUserList : {url: ServiceConfig.API_AUTH + 'user/', header: true, autherization: true, dataType: 'API'},

        // Role API
        GetRoleList : {url: ServiceConfig.API_AUTH + 'role/', header: true, autherization: true, dataType: 'API'},

        // Location List API
        GetLocationList : {url: ServiceConfig.API_AUTH + 'location/', header: true, autherization: true, dataType: 'API'},
        GetCountryList : {url: ServiceConfig.API_AUTH + 'location/countries/', header: true, autherization: true, dataType: 'API'},

        // Mapping API's
        GetMappingList : {url: ServiceConfig.API_AUTH + 'user/mapping/', header: true, autherization: true, dataType: 'API'},

        // Vendor API
        GetVendorList : {url: ServiceConfig.API_AUTH + 'vendor/', header: true, autherization: true, dataType: 'API'},

        // Customer's API
        GetCustomerList : {url: ServiceConfig.API_AUTH + 'customer/', header: true, autherization: true, dataType: 'API'},
        GetCustomerNotifyConfig: {url: ServiceConfig.API_AUTH + 'customer/notify/', header: true, autherization: true, dataType: 'API'},

        // GetLiveDeviceList API
        GetLiveDeviceList : {url: ServiceConfig.API_AUTH + 'devices/live/', header: true, autherization: true, dataType: 'API'},

        // Reboot Device API
        RebootLiveDevice : {url: ServiceConfig.API_AUTH + 'devices/live/reboot/', header: true, autherization: true, dataType: 'API'},

        // Type based monitor data
        GetTypeMonitorConfig : {url: ServiceConfig.API_AUTH + 'device/type/monitor/', header: true, autherization: true, dataType: 'API'},

        // Type based default device config
        GetDefaultDeviceConfig : {url: ServiceConfig.API_AUTH + 'device/type/config/', header: true, autherization: true, dataType: 'API'},

        // Dashboard
        GetDashboardCounts : {url: ServiceConfig.API_AUTH + 'dashboard/counts/', header: true, autherization: true, dataType: 'API'},

        // Get User Profile
        GetUserProfile : {url: ServiceConfig.API_AUTH + 'user/profile/', header: true, autherization: true, dataType: 'API'},

        // Froget Password
        ForgetPassword : {url: ServiceConfig.API_AUTH + 'user/forgot/password/', header: true, autherization: false, dataType: 'API'},

        // Froget Password
        ChangePassword : {url: ServiceConfig.API_AUTH + 'user/change/password/', header: true, autherization: true, dataType: 'API'},

        // Refresh Auth Token
        RefreshAuthToken : {url: ServiceConfig.API_AUTH + 'user/refresh/auth/', header: true, autherization: true, dataType: 'API'},

        // Download CSV file
        downloadCSVDevices : {url: ServiceConfig.API_AUTH + 'dashboard/download/', header: true, autherization: true, dataType: 'API'},

    };

    public MADServices = {
        // Auth Api
        AuthMADPlatform : {url: ServiceConfig.MADPLATFORMBASE + 'auth/login', header: false, autherization: false, dataType: 'API'},

        // Digital Billboard List
        GetDigitalBillBoards: {url: ServiceConfig.MADPLATFORMBASE + 'billboard/api/v3/rest/digital', header: true, autherization: true, dataType: 'API'},

        // Classic Billboard List
        GetClassicBillBoards: {url: ServiceConfig.MADPLATFORMBASE + 'billboard/api/v3/rest/classic', header: true, autherization: true, dataType: 'API'},

        // Get Country List
        GetMADCountires: {url: ServiceConfig.MADPLATFORMBASE + 'master/api/v2/rest/country', header: true, autherization: true, dataType: 'API'},

        // Get State List
        GetMADState: {url: ServiceConfig.MADPLATFORMBASE + 'master/api/v2/rest/state', header: true, autherization: true, dataType: 'API'},

        // Get District List
        GetMADDistrict: {url: ServiceConfig.MADPLATFORMBASE + 'master/api/v2/rest/district', header: true, autherization: true, dataType: 'API'}
    }
 }
